import PropTypes from "prop-types";
import { Component } from "react";

/**
 * ErrorBoundary
 *
 * Purpose: Reserves the application-level error boundary contract.
 * Used by: App and route-level wrappers.
 */
class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("Application error boundary caught an error", error, info);
  }

  render() {
    const { children } = this.props;
    const { hasError } = this.state;

    if (hasError) {
      return (
        <div className="min-h-screen bg-page p-8">
          <div className="mx-auto max-w-xl rounded-lg border border-danger/50 bg-surface-raised p-6 text-danger shadow-sm">
            <h1 className="text-lg font-semibold text-text-primary">
              Something went wrong
            </h1>
            <p className="mt-2 text-sm text-text-secondary">
              Please try refreshing the page.
            </p>
          </div>
        </div>
      );
    }

    return children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ErrorBoundary;
